(function($) {
	'use strict';
	$.fn.Collection__Edit = function() {
		this.each(function() {

			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this);
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

				// Get options
				var collection_edit_overlay = $('#collection--edit').html();

				// Parse it
				Mustache.parse( collection_edit_overlay );
				var output = Mustache.render( collection_edit_overlay, { title: $('h4.collection-title').text() } );

				// Add it to dom and fade it in
				$.Body.append( output );

				// Ensure Async
				setTimeout( function() {

					// Fade it in
					$.Body.addClass('overlay-white-on');

					// Add event listeners for new controllers
					$('#overlay-white.collection--edit [data-controller]').each( function() {
						$(this).Instantiate();
					});

					// Add global close overlay listener
					$.Globals.listenForGlobalCloseOverlay();

				}, 10 );

			});


		});
		return this;
	};
}(jQuery));
